import { CommonResponse } from 'models/common';
import moment from 'moment';
import { DATE_HYPHEN_FORMAT } from 'utils';
import axiosClient from 'utils/axiosClient';
import { CompanyNode, DepartmentNode, OrganizationTreeFilter } from './models';

const organizationTreeService = {
  getAll(payload: OrganizationTreeFilter): Promise<CommonResponse<CompanyNode[] | DepartmentNode[]>> {
    const dataDate = moment(payload.dataDate).format(DATE_HYPHEN_FORMAT);
    const url = `/organization-tree?data_date=${dataDate}`;
    return axiosClient.get(url);
  },
};

export default organizationTreeService;
